import { useOpen, useBlobUrl } from "../../../../../../../libs/hooks";
import { useWorkflowContainerFullStore } from "../../../../../store";
import {
  Grid,
} from "@mui/material";
import { OnlyPhoto } from "../../../../../../../libs/shared";

export const SelloNaviera = () => {


  return (
    <Grid
      container
      justifyContent="flex-start"
      alignContent="flex-start"
      alignItems="flex-start"
      spacing={0}
      sx={{ bgcolor: "white" }}
    >
      <Grid item xs={12} sx={{ mt: 1, mb: 2 }}>
        <SelloBotella />
      </Grid>
    </Grid>
  );
};

//SELLO NAVIERA 
const SelloBotella = () => {

  const {
    open: openSelloNaviera,
    handleClose: handleCloseSelloNaviera,
    handleOpen: handleOpenSelloNaviera,
  } = useOpen();

  const botellaNavieraPhoto = useWorkflowContainerFullStore(
    (state) => state.botellaNavieraPhoto
  );

  const setBotellaNavieraPhoto = useWorkflowContainerFullStore(
    (state) => state.setBotellaNavieraPhoto
  );

  const fotoUrl = useBlobUrl(botellaNavieraPhoto);

  return (
    <Grid
    item
    xs={12}
    sx={{
      mb: 2,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      pl: 1.6,
    }}
  >
    <OnlyPhoto
      foto={fotoUrl}
      handleClose={handleCloseSelloNaviera}
      handleOpen={handleOpenSelloNaviera}
      label="SELLO BOTELLA"
      open={openSelloNaviera}
      setFoto={setBotellaNavieraPhoto}
      width={220}
      fontSize={12}
    />
  </Grid>

  )
}